import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: { accessToken?: string } = {
  accessToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IjAxMDQxNDY5OTIxIiwic3ViIjoxLCJpYXQiOjE3NDA5OTgxMzQsImV4cCI6MTc0MTA4NDUzNH0.szGul3g1xl-cAw-4b0T67uX8vFsZJvnxQ6EShYc_9WY',
};

const {
  reducer,
  actions: { login, logout },
} = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    logout: (state) => {
      state.accessToken = undefined;
    },
  },
});

export { initialState, login, logout };
export default reducer;
